import React from 'react';
import { ReorderRuleExportConfiguration } from '../types/reorder_rule_export_configuration/reorderRuleExportConfiguration';

export interface ReorderRuleExportConfigurationContextProps {
  reorderRuleExportConfigurations: Map<string, ReorderRuleExportConfiguration>;
  setReorderRuleExportConfigurations: (
    reorderRuleExportConfigurations: Map<string, ReorderRuleExportConfiguration>,
  ) => void;
  reorderRuleExportConfigurationsLoading: boolean;
}

const defaultContext: ReorderRuleExportConfigurationContextProps = {
  reorderRuleExportConfigurations: new Map(),
  setReorderRuleExportConfigurations: () => {},
  reorderRuleExportConfigurationsLoading: false,
};

export const ReorderRuleExportConfigurationContext =
  React.createContext<ReorderRuleExportConfigurationContextProps>(defaultContext);
